module.exports = __webpack_public_path__ + "static/media/comments-panel-icon.5d3eae20.svg";